import React from "react";
import "../../../../assets/css/public.scss";
import {Link, useHistory} from "react-router-dom";
import {route, trans, widget} from "../../../modulesCompiler";


const PublicHeaderNav = ({mobile}) => {
    let history = useHistory();

    const mobilePrevent = (e) => {
        //if(mobile) e.preventDefault();
    }

    return (
        <nav className="header_nav d-md-flex">
            {[
                {id: "index", route: route("public.index"), trans: trans("naslovna")},
                {id: "about" ,route: route("public.about"), trans: trans("o nama")},
                {id: "shop", route: route("products.shop"), trans: trans("shop")},
                /*{id: "action", route: route("products.action"), trans: trans("akcija")},*/
                {id: "prodajna", route: route("public.places"), trans: trans("prodajna mesta")},
                {id: "blog", route: route("blog.blogs"), trans: trans("blog")},
                {id: "kontakt", route: route("public.contact"), trans: trans("kontakt")},
            ].map((item, index) => {
                return  <div key={item.id}>
                    <Link onClick={mobilePrevent} to={item.route}
                          className={`${history.location.pathname === item.route  ? "active" : ""} w-100 header_nav_link fw-bold text-uppercase`}>
                        <span style={{whiteSpace: "nowrap"}}> {item.trans} </span>
                    </Link>

                    {item.id === "shop" && !mobile &&
                    <div className="position-absolute bg-primary header_nav_dropdown w-100 shadow-sm">
                        {widget("categories.DropDownMenu")}
                    </div>}
                </div>
            })}
        </nav>
    )
}

export default PublicHeaderNav;
